import React from 'react';
function Check() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" })));
}
export default Check;
